// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"70124721","284":"2fab02ab","473":"2fab02ab","826":"2818b0c3","875":"2fab02ab"}[chunkId] + ".chunk.css";
};